import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {IEmailModel} from '../../core/interfaces/email.interface';
import {EmailStatus} from '../../core/enums/email-status.enum';
import {format} from 'date-fns';

@Component({
    selector: 'view-email',
    templateUrl: 'view-email.component.html',
    styleUrls: ['view-email.component.css', '../../../styles/form.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ViewEmailComponent implements OnInit {
  public email: IEmailModel;
  public emailStatus: string;
  public createDate: string;
  public disableSendAgain: boolean = false;
  
  constructor(private route: ActivatedRoute) {
  }

  public ngOnInit() {
    this.route.data.subscribe((data: any) => {
      this.email = data.email as IEmailModel;
      this.emailStatus = this.statusDescription(this.email.status);
      this.createDate = format(this.email.createDate, 'M/D/YY h:mm a');
    });
  }

    // todo: refactor
  private statusDescription(status: number): string {
    switch (status) {
      case EmailStatus.Unknown: return 'Unknown';
      case EmailStatus.Queued: return 'Queued';
      case EmailStatus.Sent: return 'Sent';
      case EmailStatus.Resent: return 'Resent';
      case EmailStatus.Failed: return 'Failed';
    }
  }
}
